import { Record } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as CreateSalesforceCampaignActionMetadataKeys from 'automation-ui-action-features/actions/create-salesforce-campaign/CreateSalesforceCampaignActionMetadataKeys';
export default class CreateSalesforceCampaignActionMetadata extends Record({
  [CreateSalesforceCampaignActionMetadataKeys.ACTION_TYPE]: ActionTypes.CREATE_SALESFORCE_CAMPAIGN,
  [CreateSalesforceCampaignActionMetadataKeys.CAMPAIGN_ID]: null,
  [CreateSalesforceCampaignActionMetadataKeys.STATUS]: null
}, 'CreateSalesforceCampaignActionMetadata') {}